import React, { Component } from 'react';
import ajax from 'superagent';
import { Field } from 'redux-form';
import SelectField from './SelectField';

class StatesList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            states: [],
            name: props.name === undefined ? 'state_id' : props.name
        };
    }
    componentWillMount() {
        const ROOT_URL = process.env.API_URL;
        ajax.get(ROOT_URL + '/states')
            .end((error, response) => {
                if (!error && response) {
                    this.setState({ states: response.body.states });
                } else {
                    console.log('There was an error fetching from API', error);
                }
            }
        );
    }

    render() {
        return (
            <div className="col-md-12 col-lg-12">
                <div className="form-group">
                    <Field 
                        className="form-control" 
                        name={this.state.name}
                        component={SelectField} 
                        options={this.state.states} 
                        defaultValue={'Provincias'}
                        label={'Provincia'}
                        type={this.props.type}
                    />
                </div>
            </div>
        );
    }
}

export default StatesList;



/** WEBPACK FOOTER **
 ** ./src/components/States.js
 **/